export const LICENCE_EXPIRED = "Licence expired!";
